export default __webpack_public_path__ + "static/media/header-3.0f5d6cc1.jpg";